import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { Chart } from '../Charts/ChartWrapper';

import axios from 'axios';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControlLabel, Popover, RadioGroup, Radio, Slider, Switch } from '@mui/material';
import {CcLoader, InfoToolTip, LionLoaderGradient, TabSelector} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {InputText, InputNumber, InputURL, FileSelector, LionListbox, CcCheckbox} from '../commonComponents/inputFields'
import {MaxIntInArray, RandomInt, RandomGradientPairHex, RandomGradientHex, TryParseIntDefault} from "../components/helpers";
import { Icon as Iconify } from '@iconify/react';


import { getErrorListFromYupError, getErrorMessage, snippetDataChartsValidationSchema } from '../components/helperErrors'
import { lionIcons } from '../components/helpersIcons';
import { allChartsMetadata } from '../Charts/metadata';
import { Helmet } from 'react-helmet';
import { CcActionButton, CcActionButtonOutlined, CcSecondaryActionButtonOutlined } from '../commonComponents/styledTexts';
import { string } from 'yup';
import { LionColorPicker } from '../components/lionColorPicker';
import { DatafeedPicker } from '../components/datafeedGrid';
import { DatabindingSelector } from '../components/templateEditor';
import { backgroundPlugin, progressBackgroundPlugin, CenterBarLabelsPlugin } from "../Charts/gradientHelper";
import { ApplyFormatterFunction } from '../Charts/formatters';

const ChartGallery = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(undefined)

  useEffect(() => {
     handleSelectedChartChange(0, allChartsMetadata[0].metadata, allChartsMetadata[0].title)
   
  }, [])

  const handleSelectedChartChange = (index, metadata, title) => {
    setSelectedIndex(index)
    if (props.onChange) props.onChange(metadata, title)
  }
 
    return <div className='flex flex-row flex-wrap gap-4 font-poppins text-ccColorDarkTeal'> 
            {allChartsMetadata.map((m, index) => <div className={`w-fit flex flex-col items-center border border-ccColorDarkTeal p-2 rounded hover:bg-slate-200 hover:cursor-pointer ${selectedIndex === index ? 'border-2 bg-teal-50' : ''}`} onClick={()=>handleSelectedChartChange(index, m.metadata, m.title)}> 
                <div className='text-lg font-semibold'>{m.title}</div>
                <Chart metadata={m.metadata} />
            </div>)}
    </div>
}

export function ChartElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetHref, setSnippetHref] = useState('')



  useEffect(() => {
    //console.log(props.snippetInfo)
    if (props.snippetInfo === undefined && settings === undefined) return;

    if (props.snippetInfo) { //we are in edit
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetHref(props.snippetInfo.href)
    }
    else {

    }

  }, [props.templateId, props.snippetInfo, props.resourcesByLanguage, settings])



  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 23,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};
    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.href = snippetHref;
 
    if (updatePropName) {
      result[updatePropName] = updatePropValue;
      //console.log(result)
  }
    return result;
  }

  const handleFallbackImageChange = (dataURL) => {

    const newSettings = {...props.fallback, fallbackImage: dataURL}
    if (props.onFallbackChange) props.onFallbackChange(newSettings)
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleSnippetHrefChange = (newValue) => {
    
    setSnippetHref(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('href', newValue))
  }
  const handleFallbackTypeChange = (fType) => {
    if (props.onFallbackChange) props.onFallbackChange({fallbackType: fType, fallbackImage: ''})
  }

  return <div>
  <div className='flex flex-col gap-4 justify-center items-center'>
      <div className=" w-1/2 mt-10 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
    <div className="sm:col-span-3">
      <InputText
              displayName="Element name"
              value={snippetName}
              onChange={(val) => {handleSnippetNameChange(val);}}
              error={getErrorMessage(props.validationErrorsList, 'snippetName')}
      />
    </div>

    <div className="sm:col-span-3">
      <InputText
                displayName="Description"
                value={snippetDesc}
                onChange={(val) => {handleSnippetDescChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
      />
    </div>


    <div className="sm:col-span-6">
      <div  className="text-sm font-poppins font-medium text-gray-900">Href</div>
      <InputURL
                value={snippetHref}
                onChange={(val) => {handleSnippetHrefChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'href')}
              />
    </div>  

  <div className="sm:col-span-6">
    <div className='font-semibold text-lg'>Fallback</div>
    <div class="inline-flex rounded-md shadow-sm font-poppins text-ccColorDarkTeal" role="group">
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.fallback?.fallbackType === 'showImage' ? 'bg-gray-200' : 'bg-white'}`}
            onClick={() => handleFallbackTypeChange('showImage')}>
        <div>
          Default Image
        </div>
        <div className='text-sm mt-2 font-normal'>Show your uploaded image</div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.fallback?.fallbackType === 'hide' || props.fallback == undefined ? 'bg-gray-200' : 'bg-white'}`}
          onClick={() => handleFallbackTypeChange('hide')}>
        <div>
          Collapse
        </div>
        <div className='text-sm mt-2 font-normal'>Hide the chart completely</div>
      </div>
    </div>

    {props.fallback?.fallbackType === 'showImage' && <>
      <div className='mt-2 flex flex-row gap-2 items-center'>
        <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
            Default Image
        </label>
        <InfoToolTip
        placement='right'
        headLine='Default Image'
        message="You can optionally show this image instead of the chart any time the chart can't be generated. For example when the merged data is corrupted."
        />
      </div>
      <div className="sm:col-span-6">
        <FileSelector noDeleteButton
          onChange={handleFallbackImageChange}
          base64={props.fallback?.fallbackImage.length > 0 ? props.fallback?.fallbackImage.split(',')[1] : undefined}
          />
      </div>
      {props.fallbackImageError && <div className='text-red-500'>Please provide an image</div>}
    </>}

  </div>

</div>

</div>

  </div>
}
const DataBindindPrettyLabel = (props) => {
  const [prettyLabel, setPrettyLabel] = useState("")
  const [prettyLabelValue, setPrettyLabelValue] = useState("")

  useEffect(() => {
    if (props.dataBindType == undefined || props.dataBindValue == undefined) {
        setPrettyLabel("Same as design time")
        setPrettyLabelValue("")
        return
    }

    switch (props.dataBindType) {
      case "databind":
        setPrettyLabel("From feed:")
        setPrettyLabelValue(props.dataBindValue)
        break;
      case "urlChartSeries":
        setPrettyLabel("From URL parameter:")
        setPrettyLabelValue(props.dataBindValue)
        break;
      default:
        setPrettyLabel("Same as design time")
        setPrettyLabelValue("")
    }
    
  }, [props.dataBindType, props.dataBindValue])

  return <div className='border border-ccColorTeal rounded font-poppins px-2 py-1 text-sm flex flex-row items-center gap-x-1'>
    <div>{prettyLabel}</div>
    {prettyLabelValue.length > 0 && <div className='bg-slate-200 rounded px-1'>{prettyLabelValue}</div>}
    </div>
}
const ChartTitleEditor = (props) => {

  const handleTitlePropChange = (propName, propValue) => {
    const newTitle = {...props.metadata.options.plugins.title, [propName]: propValue}
    const newPlugins = {...props.metadata.options.plugins, title: newTitle}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    const newMetadata = {...props.metadata, options: newOptions}

    if (props.onChange) props.onChange(newMetadata)
  }

  return <div className='border rounded text-ccColorDarkTeal'>

          <FormGroup>
          <FormControlLabel control={<Switch
                                      checked={props.metadata.options.plugins.title.display}
                                      onChange={(e) => handleTitlePropChange('display', e.target.checked)}
                                      inputProps={{ 'aria-label': 'controlled' }}
                                      sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                  />} label="Show Title"
          />
          </FormGroup>
        {props.metadata.options.plugins.title.display &&  <div>
          <div className="mr-2">
            <InputText
                    displayName="Title"
                    value={props.metadata.options.plugins.title.text}
                    onChange={(val) => handleTitlePropChange('text', val)}
            />
          </div>
          <div className='mt-2 mb-2'>
            <div className='block text-sm font-medium text-gray-900'>Title color</div>
            <LionColorPicker color={props.metadata.options.plugins.title.color}
                  onChange={(color) => handleTitlePropChange('color', color)}
            />
          </div>

        </div>
        }
  </div>
}
const ChartSeriesEditor = (props) => {

  const hadleAxisLabelsChange = (index, lblValue) => {
    const labels = [...props.metadata.data.labels]
    labels.splice(index, 1, lblValue)

    const newData = {...props.metadata.data, labels: labels}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleAxisLabelsRemove = (index) => {
    const labels = [...props.metadata.data.labels]
    labels.splice(index, 1)

    const newData = {...props.metadata.data, labels: labels}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleAxisLabelsAdd = () => {
    const labels = [...props.metadata.data.labels]
    labels.push('')

    const newData = {...props.metadata.data, labels: labels}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleAxisLabelsDatabindChange = (bindType, dataBindValue,) => {
    const newData = {...props.metadata.data, ccLabelsDatabindType: bindType, ccLabelsDatabindValue: dataBindValue}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleDatasetChange = (dsIndex, valueIndex, dataValue) => {
    const newDatasets = [...props.metadata.data.datasets]
    const newDataset = {...newDatasets[dsIndex]}
    newDataset.data.splice(valueIndex, 1, dataValue)

    newDatasets.splice(dsIndex, 1, newDataset)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleDatasetDatabindChange = (dsIndex, databindType, databindValue) => {
    const newDatasets = [...props.metadata.data.datasets]
    const newDataset = {...newDatasets[dsIndex], databindType: databindType, databindValue: databindValue}
    newDatasets.splice(dsIndex, 1, newDataset)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleDatasetDataRemove = (dsIndex, valueIndex) => {
    const newDatasets = [...props.metadata.data.datasets]
    const newDataset = {...newDatasets[dsIndex]}
    newDataset.data.splice(valueIndex, 1)

    newDatasets.splice(dsIndex, 1, newDataset)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleDatasetDataAdd = (dsIndex) => {
    const newDatasets = [...props.metadata.data.datasets]
    const newDataset = {...newDatasets[dsIndex]}
    newDataset.data.push(0)

    newDatasets.splice(dsIndex, 1, newDataset)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleDatasetAdd = () => {
    const newDatasets = [...props.metadata.data.datasets]
    const newDataset = {...newDatasets[0], databindType: undefined, databindValue: undefined}
    const count = newDataset.data.length
    const maxValue = MaxIntInArray(newDataset.data)

    const newValues = []
    for (let i=0; i<count; i+=1) {
      newValues.push(RandomInt(0, maxValue))
    }

    //adding default colors...
    //const gradientColors = RandomGradientPairHex();
    if (props.metadata.type === 'line') {
      const gradientColors = RandomGradientHex(2);
      newDatasets.push({...newDataset, data: newValues, borderColor: gradientColors[0], pointBackgroundColor: gradientColors[1]})
    }
    else {
      //this is for bars and pies so far
      const gradientColors = props.metadata.type === 'bar' ? RandomGradientHex(2) : RandomGradientHex(5);
      newDatasets.push({...newDataset, data: newValues, backgroundColor: gradientColors})
    }

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleDatasetRemove = (index) => {
    const newDatasets = [...props.metadata.data.datasets]
    newDatasets.splice(index)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const getSeriesColor = (ds, index) => {
    // we need to read the backgroundColor prop which can be a string or an array of strings or a function
    if (typeof ds.backgroundColor !== 'string' && !Array.isArray(ds.backgroundColor)) {
      //if we are here it's a function
      //it means there is a gradient applied and the colors are in the gradientColors prop
      return ds.gradientColors[index]
    }

    if (typeof ds.backgroundColor === 'string') {
      if (index > 0) return '#000000'
      else return ds.backgroundColor
    }
    else {
      //if we are here it's an array
      return ds.backgroundColor[index]
    }
  }
  const isSeriesColorGradient = (ds) => {
    if (typeof ds.backgroundColor !== 'string' && !Array.isArray(ds.backgroundColor)) {
      //if we are here the backgroundColor is a function
      //it means there is a gradient
      return true
    }

    if (typeof ds.backgroundColor === 'string') {
      return false
    }
    else {
      //if we are here it's an array
      return true
    }
  }
  const setSeriesColorAsGradient = (dsIndex, isGradient) => {
    const newDatasets = [...props.metadata.data.datasets]

    if (isGradient) {
      const color1 = newDatasets[dsIndex].backgroundColor
      const color2 = '#000000'
      const newGradientColors = [color1, color2]
      newDatasets[dsIndex].backgroundColor = newGradientColors
    }
    else {
      newDatasets[dsIndex].backgroundColor = newDatasets[dsIndex].gradientColors[0]
      newDatasets[dsIndex].gradientColors = undefined
    }
    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleSeriesColorChange = (dsIndex, colorIndex, color) => {
    const newDatasets = [...props.metadata.data.datasets]

    if (isSeriesColorGradient(newDatasets[dsIndex])) {
      const newGradientColors = [...newDatasets[dsIndex].gradientColors]
      newGradientColors.splice(colorIndex,1,color)
      newDatasets[dsIndex].gradientColors = newGradientColors
    }
    else {
      newDatasets[dsIndex].backgroundColor = color
    }
    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handlePieDatasetChange = (ds, dsIndex) => {
    const newDatasets = [...props.metadata.data.datasets]

    newDatasets.splice(dsIndex, 1, ds)

    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }

  return <div>
    <div className='border rounded px-2 py-1'>
      <div className='font-semibold'>Axis Labels</div>
      <div className='flex flex-row items-center gap-x-1'>
        <div className=''>Design time values</div>
        <InfoToolTip 
          placement='right'
          headLine='Design time values'
          message="These are placeholders to use while editing this chart"
        />
      </div>
      <div className='flex flex-row flex-wrap gap-x-4 gap-y-2'>
        {props.metadata.data.labels.map((l, index) => <div className='w-36 flex flex-row items-center'>
                <InputText
                    displayName=""
                    value={l}
                    onChange={(val) => {hadleAxisLabelsChange(index, val);}}
                />
                <div className='rounded-full p-1 hover:bg-slate-200 cursor-pointer'
                    onClick={() => hadleAxisLabelsRemove(index)}>
                   <Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} />
                </div>
          </div>)}
        <div className='border border-ccColorTeal rounded p-1 hover:bg-slate-200 cursor-pointer flex flex-row gap-x-1 items-center'
            onClick={hadleAxisLabelsAdd}>
            <Iconify icon={lionIcons.Icon_Actions_Add} width={24} />
            <div>Add new</div>
        </div>
      </div>
      <div className='flex flex-row items-center gap-x-1 mt-2'>
        <div className=''>Live values</div>
        <InfoToolTip 
          placement='right'
          headLine='Live values'
          message="Here you can set which values will be displayed live. The values can come from data merged in the tag or from a Data Connection"
        />
      </div>
      <div className='flex flex-row items-center'>
        <DataBindindPrettyLabel
            dataBindType={props.metadata.data.ccLabelsDatabindType}
            dataBindValue={props.metadata.data.ccLabelsDatabindValue}
        />
        <DatabindingSelector dataBindValue={props.metadata.data.ccLabelsDatabindValue ? props.metadata.data.ccLabelsDatabindValue : `xLbl`}
            sampleData={props.sampleData}
            noPreview
            allowArraysSelection
            dataBindType={props.metadata.data.ccLabelsDatabindType ? props.metadata.data.ccLabelsDatabindType : 'designTimeValues'}
            dataBindTypes={props.metadata.ccFeedId ? ['designTimeValues', 'databind'] : ['designTimeValues', 'urlChartSeries']}
            onChange={handleAxisLabelsDatabindChange}
        />
       </div>
      

    </div>

    <div className='border rounded px-2 py-1 mt-2 flex flex-col gap-y-3'>
      {props.metadata.data.datasets.map((ds, index) => <div>
        <div className='flex flex-row items-center gap-x-1'>
          <div className='font-semibold'>Series {index+1}</div>
          {index > 0 && !props.noAddDeleteSeries && <div onClick={() => handleDatasetRemove(index)} className='cursor-pointer rounded-full p-1 hover:bg-slate-200'><Iconify icon={lionIcons.Icon_Actions_Delete} width={20}/></div>}
        </div>
        <div className='flex flex-row items-center gap-x-1'>
          <div className=''>Design time values</div>
          <InfoToolTip 
            placement='right'
            headLine='Design time values'
            message="These are placeholders to use while editing this chart. Use the same number of values as the number of labels"
          />
        </div>
        <div className='flex flex-row flex-wrap gap-x-4 gap-y-2'>
          {ds.data.map((d, dIndex) => <div className='w-40 flex flex-row items-center'>
                  <InputNumber small
                      displayName=""
                      value={d}
                      onChange={(val) => {hadleDatasetChange(index, dIndex, val);}}
                  />
                  <div className='rounded-full p-1 hover:bg-slate-200 cursor-pointer'
                      onClick={() => handleDatasetDataRemove(index, dIndex)}>
                    <Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} />
                  </div>
            </div>)}
          <div className='border border-ccColorTeal rounded p-1 hover:bg-slate-200 cursor-pointer flex flex-row gap-x-1 items-center'
              onClick={() => hadleDatasetDataAdd(index)}>
              <Iconify icon={lionIcons.Icon_Actions_Add} width={24} />
              <div>Add new</div>
          </div>
        </div>
        <div className='flex flex-row items-center gap-x-1 mt-2'>
          <div className=''>Live values</div>
          <InfoToolTip 
            placement='right'
            headLine='Live values'
            message="Here you can set which values will be displayed live. The values can come from data merged in the tag or from a Data Connection"
          />
        </div>
        <div className='flex flex-row items-center'>
          <DataBindindPrettyLabel
              dataBindType={ds.databindType}
              dataBindValue={ds.databindValue}
          />
          <DatabindingSelector dataBindValue={ds.databindValue ? ds.dataBindValue : `s${index+1}`}
              sampleData={props.sampleData}
              noPreview
              allowArraysSelection
              dataBindType={ds.databindType ? ds.databindType : 'designTimeValues'}
              dataBindTypes={props.metadata.ccFeedId ? ['designTimeValues', 'databind'] : ['designTimeValues', 'urlChartSeries']}
              onChange={(bindType, dataBindValue) => handleDatasetDatabindChange(index, bindType, dataBindValue)}
          />
        </div>
        {props.metadata.type === 'bar' &&
          <div className='flex flex-row gap-x-8 items-end'>
            <div className='mt-2 mb-2'>
              <div className='block text-sm font-medium text-gray-900'>Color 1</div>
              <LionColorPicker color={getSeriesColor(ds, 0)}
                  onChange={(color) => handleSeriesColorChange(index, 0, color)}
              />
            </div>
            <div className='mt-2 mb-2'>
              <div className='flex flex-row items-center gap-x-2 -mb-1'>
                <div className='block text-sm font-medium text-gray-900'>Color 2</div>
                <FormGroup>
                <FormControlLabel control={<Switch
                                            checked={isSeriesColorGradient(ds)}
                                            onChange={(e) => setSeriesColorAsGradient(index, e.target.checked)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                        />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'></div>}
                />
                </FormGroup>
                <div className='-ml-6'>
                  <InfoToolTip 
                    placement='right'
                    headLine='Color gradient'
                    message={<div>Enable <span className='font-bold'>Color 2</span> to apply a gradient to this series</div>}
                  />
                </div>
              </div>
              {isSeriesColorGradient(ds) &&  <LionColorPicker color={getSeriesColor(ds, 1)}
                  onChange={(color) => handleSeriesColorChange(index, 1, color)}
              />
              }
              {!isSeriesColorGradient(ds) &&  <div className='h-10 flex items-center'>
                <div className='font-poppins text-gray-500'>Not used</div>
              </div>
              }
            </div>

          </div>
        }
        {props.metadata.type === 'pie' && <div className='mt-2'><PieDatasetEditor 
                                              dataset={ds}
                                              onChange={(ds) => handlePieDatasetChange(ds, index)}
                                            />
                                          </div>
        }
        {props.metadata.type === 'line' && <div className='mt-2'><LineDatasetEditor 
                                              dataset={ds}
                                              onChange={(ds) => handlePieDatasetChange(ds, index)}
                                            />
                                          </div>
        }
        

      </div>)}
      {!props.noAddDeleteSeries && <div className='w-fit'>
        <CcSecondaryActionButtonOutlined 
          onClick={handleDatasetAdd}
        >Add series</CcSecondaryActionButtonOutlined>

      </div>
}
      
    </div>
  </div>

}

const ProgressBarValueRangeEditor = (props) => {

  const handleRangeChange = (propName, propValue) => {
    const newScaleX = {...props.metadata.options.scales.x, [propName]: propValue}
    const newScales = {...props.metadata.options.scales, x: newScaleX}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleRangeMinValueDatabindChange = (bindType, dataBindValue,) => {
    const newScaleX = {...props.metadata.options.scales.x, ccMinDatabindType: bindType, ccMinDatabindValue: dataBindValue}
    const newScales = {...props.metadata.options.scales, x: newScaleX}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleRangeMaxValueDatabindChange = (bindType, dataBindValue,) => {
    const newScaleX = {...props.metadata.options.scales.x, ccMaxDatabindType: bindType, ccMaxDatabindValue: dataBindValue}
    const newScales = {...props.metadata.options.scales, x: newScaleX}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }

  return <div>
    <div className='border rounded px-2 py-1'>
      <div className='font-semibold'>Progress Bar value range</div>
      <div className='flex flex-row items-center gap-x-1'>
        <div className=''>Design time values</div>
        <InfoToolTip 
          placement='right'
          headLine='Design time values'
          message="These are placeholders to use while editing this chart"
        />
      </div>
      <div className='flex flex-row flex-wrap gap-x-4 gap-y-2'>
        <div className='mt-2 w-44'>
            <InputNumber displayName="Min value"
            min={0} max={10000000} incr={1}
            onChange={(val) => handleRangeChange('min', val)}
            value={props.metadata.options.scales.x.min}
            />
        </div>
        <div className='mt-2 w-44'>
            <InputNumber displayName="Max value"
            min={0} max={10000000} incr={1}
            onChange={(val) => handleRangeChange('max', val)}
            value={props.metadata.options.scales.x.max}
            />
        </div>

      </div>
      <div className='flex flex-row items-center gap-x-1 mt-2'>
        <div className=''>Live values</div>
        <InfoToolTip 
          placement='right'
          headLine='Live values'
          message="Here you can set which values will be displayed live. The values can come from data merged in the tag or from a Data Connection"
        />
      </div>
      <div className='flex flex-row items-center gap-x-4'>
        <div>
          <div>Min value</div>
          <div className='flex flex-row items-center'>
            <DataBindindPrettyLabel
                dataBindType={props.metadata.options.scales.x.ccMinDatabindType}
                dataBindValue={props.metadata.options.scales.x.ccMinDatabindValue}
            />
            <DatabindingSelector dataBindValue={props.metadata.options.scales.x.ccMinDatabindValue ? props.metadata.options.scales.x.ccMinDatabindValue : `xmin`}
                sampleData={props.sampleData}
                noPreview
                allowArraysSelection
                dataBindType={props.metadata.options.scales.x.ccMinDatabindType ? props.metadata.options.scales.x.ccMinDatabindType : 'designTimeValues'}
                dataBindTypes={props.metadata.ccFeedId ? ['designTimeValues', 'databind'] : ['designTimeValues', 'urlChartSeries']}
                onChange={handleRangeMinValueDatabindChange}
            />
          </div>
        </div>
        <div>
          <div>Max value</div>
          <div className='flex flex-row items-center'>
            <DataBindindPrettyLabel
                dataBindType={props.metadata.options.scales.x.ccMaxDatabindType}
                dataBindValue={props.metadata.options.scales.x.ccMaxDatabindValue}
            />
            <DatabindingSelector dataBindValue={props.metadata.options.scales.x.ccMaxDatabindValue ? props.metadata.options.scales.x.ccMaxDatabindValue : `xmax`}
                sampleData={props.sampleData}
                noPreview
                allowArraysSelection
                dataBindType={props.metadata.options.scales.x.ccMaxDatabindType ? props.metadata.options.scales.x.ccMaxDatabindType : 'designTimeValues'}
                dataBindTypes={props.metadata.ccFeedId ? ['designTimeValues', 'databind'] : ['designTimeValues', 'urlChartSeries']}
                onChange={handleRangeMaxValueDatabindChange}
            />
          </div>
        </div>
      </div>
    </div>
  </div>

}
const ProgressBarValueRangeEditorSimple = (props) => {

  const handleRangeChange = (propName, propValue) => {
    const newScaleX = {...props.metadata.options.scales.x, [propName]: propValue}
    const newScales = {...props.metadata.options.scales, x: newScaleX}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }

  return <div>
      <div className='flex flex-row flex-wrap gap-x-4 gap-y-2'>
        <div className='mt-2 w-44'>
            <InputNumber displayName="Min value"
            min={0} max={10000000} incr={1}
            onChange={(val) => handleRangeChange('min', val)}
            value={props.metadata.options.scales.x.min}
            />
        </div>
        <div className='mt-2 w-44'>
            <InputNumber displayName="Max value"
            min={0} max={10000000} incr={1}
            onChange={(val) => handleRangeChange('max', val)}
            value={props.metadata.options.scales.x.max}
            />
        </div>

      </div>
  </div>

}

const PieDatasetEditor = (props) => {
  //props:
  // dataset

  const piePalette = [
        ['#1D4ED8', '#3B82F6', '#93C5FD', '#EFF6FF'] //blue
        ['#BE185D', '#EC4899', '#F9A8D4', '#FDF2F8'], //pink
        ['#6366F1', '#A5B4FC', '#E0E7FF', '#EEF2FF'], //indigo
        ['#0F766E', '#2DD4BF', '#99F6E4', '#ECFEFF'], // teal  
  ]
  const handleDatasetsChange = (propName, propValue) => {
    const newDataset = {...props.dataset, [propName]: propValue}

    if (props.onChange) props.onChange(newDataset)
  }
  const handleDatasetsColorChange = (index, color) => {
    const newColors = [...props.dataset.backgroundColor]
    newColors.splice(index, 1, color)
    const newDataset = {...props.dataset, backgroundColor: newColors}

    if (props.onChange) props.onChange(newDataset)
  }
  const handleDatasetsColorAdd = () => {
    const newColors = [...props.dataset.backgroundColor, '#000000']
    const newDataset = {...props.dataset, backgroundColor: newColors}

    if (props.onChange) props.onChange(newDataset)
  }
  const handleDatasetsColorRemove = (index) => {
    const newColors = [...props.dataset.backgroundColor]
    newColors.splice(index,1)
    const newDataset = {...props.dataset, backgroundColor: newColors}

    if (props.onChange) props.onChange(newDataset)
  }

  return <div className='bg-slate-100 rounded px-2 pb-2'>
      <div className='text-ccColorDarkTeal text-lg font-semibold'>Slice properties</div>
        <div className='flex flex-row items-start gap-x-4'>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Spacing (px)"
                min={0} max={50} incr={1}
                onChange={(val) => handleDatasetsChange('spacing', val)}
                value={props.dataset.spacing}
                />
            </div>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Border radius (px)"
                min={0} max={50} incr={1}
                onChange={(val) => handleDatasetsChange('borderRadius', val)}
                value={props.dataset.borderRadius}
                />
            </div>
        </div>
        <div className='flex flex-row items-start gap-x-4'>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Border width (px)"
                min={0} max={50} incr={1}
                onChange={(val) => handleDatasetsChange('borderWidth', val)}
                value={props.dataset.borderWidth}
                />
            </div>
              <div className='mt-2 mb-2'>
                <div className='block text-sm font-medium text-gray-900'>Border background color</div>
                <LionColorPicker color={props.dataset.borderColor}
                onChange={(color) => handleDatasetsChange('borderColor', color)}
                />
              </div>
        </div>
        <div>
        <div className='mt-2 flex flex-row flex-wrap gap-x-4 gap-y-1'>
          {props.dataset.backgroundColor.map((c, cIndex) => <div className='w-40 flex flex-row items-center'>
              <div className=''>
                <div className='block text-sm font-medium text-gray-900'>Color {cIndex+1}</div>
                <LionColorPicker color={c}
                onChange={(color) => handleDatasetsColorChange(cIndex, color)}
                />
              </div>
              <div className='rounded-full p-1 mt-4 hover:bg-slate-200 cursor-pointer'
                  onClick={() => handleDatasetsColorRemove(cIndex)}>
                  <Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} />
              </div>

            </div>)}
        </div>
        <div className='w-fit mt-2 border border-ccColorTeal rounded p-1 hover:bg-slate-200 cursor-pointer flex flex-row gap-x-1 items-center'
            onClick={handleDatasetsColorAdd}
            >
            <Iconify icon={lionIcons.Icon_Actions_Add} width={24} />
            <div>New color</div>
        </div>
        </div>
</div>
}
const LineDatasetEditor = (props) => {
  //props:
  // dataset

  const handleDatasetsChange = (propName, propValue) => {
    const newDataset = {...props.dataset, [propName]: propValue}

    if (props.onChange) props.onChange(newDataset)
  }

  return <div className='bg-slate-100 rounded px-2 pb-2'>
      <div className='text-ccColorDarkTeal text-lg font-semibold'>Line and Points properties</div>
        <div className='flex flex-row items-start gap-x-4'>
          <div className='mt-2 mb-2'>
            <div className='block text-sm font-medium text-gray-900'>Line color</div>
            <LionColorPicker color={props.dataset.borderColor}
            onChange={(color) => handleDatasetsChange('borderColor', color)}
            />
          </div>
          <div className='mt-2 mb-2'>
            <div className='block text-sm font-medium text-gray-900'>Point color</div>
            <LionColorPicker color={props.dataset.pointBackgroundColor}
            onChange={(color) => handleDatasetsChange('pointBackgroundColor', color)}
            />
          </div>
        </div>
        <div className='flex flex-row items-start gap-x-4'>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Point radius (px)"
                min={0} max={50} incr={1}
                onChange={(val) => handleDatasetsChange('pointRadius', val)}
                value={props.dataset.pointRadius}
                />
            </div>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Line tension"
                min={0} max={1} incr={.1}
                onChange={(val) => handleDatasetsChange('tension', val)}
                value={props.dataset.tension}
                />
            </div>
        </div>
</div>
}

const ChartEditor = (props) => {

  const [showPreview, setShowPreview] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewImageDataUrl, setPreviewImageDataUrl] = useState('');
  const [previewFilters, setPreviewFilters] = useState(undefined);
  const [openDialogChartChange, setOpenDialogChartChange] = useState(false);
  const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});
  const tabItems = [{id: 'chart', name: 'Chart'}, {id: 'data', name: 'Data'}] 
  const [currentTab, setCurrentTab] = useState('chart')
  const [dataConnectionInfo, setDataConnectionInfo] = useState(undefined);
  const [sampleData, setSampleData] = useState({});

  useEffect(() => {
    updateDataConnection(props.dataConnectionId)
  }, [props.dataConnectionId])

  const handleChange = (metadata) => {
    if (props.onChange) props.onChange(metadata)
  }
  const closePreview = () => {
    setShowPreview(false);
    setPreviewImageDataUrl('')
  }
  const handleOpenPreview = (e, filters) => {
    const urlParameters = [{name: 'xLbl', value: props.metadata.data.labels}]
    for (const ds of props.metadata.data.datasets) {
      if (ds.databindType && ds.databindType === 'urlChartSeries') {
        urlParameters.push({name: ds.databindValue, value: ds.data})
      }
    }
    if (props.selectedChartId === 'Progress Bar') {
      urlParameters.push({name: 'xmin', value: props.metadata.options.scales.x.min})
      urlParameters.push({name: 'xmax', value: props.metadata.options.scales.x.max})
    }
    const clearFilters = {position: 1, urlParameters: urlParameters}
    //console.log(clearFilters)


    //IF filters is undefined THEN it's the first preview open -> we clear the filters
    if (filters == undefined) filters = clearFilters

    setPreviewFilters(filters)
    getChartPreview(props.metadata, filters)
    setPreviewLoading(true)
    setShowPreview(true)
  }
  const handlePreviewFiltersPositionChange = (increment) => {
    const newFilters = {...previewFilters, position: previewFilters.position + increment}
    //console.log(newFilters)
    handleOpenPreview(null, newFilters)
  }
  const handleRefreshPreview = () => {
    handleOpenPreview(null, previewFilters)
  }
  const handlePreviewParametersUrlMergeChangeArr = (paramName, paramValue) => {
    const newUrlParams = [...previewFilters.urlParameters]
    let paramValueArr = paramValue.split(',')
    newUrlParams.find(p => p.name === paramName).value = paramValueArr
    const newPreviewFilters = {...previewFilters, urlParameters: newUrlParams}

    console.log(newPreviewFilters)
    setPreviewFilters(newPreviewFilters)
    
  }
  const handlePreviewParametersUrlMergeChangeNumber = (paramName, paramValue) => {
    const newUrlParams = [...previewFilters.urlParameters]
    newUrlParams.find(p => p.name === paramName).value = parseFloat(paramValue)
    const newPreviewFilters = {...previewFilters, urlParameters: newUrlParams}

    console.log(newPreviewFilters)
    setPreviewFilters(newPreviewFilters)
    
  }

  const handleChartSizeChange = (width, height) => {
    const newMetadata = {...props.metadata, ccResize: true}
    if (width) newMetadata.ccWidth = width
    if (height) newMetadata.ccHeight = height
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleChartBackgroudColorChange = (color) => {

    const newPlugins = {...props.metadata.options.plugins, customCanvasBackgroundColor: {color: color}}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarBackgroudColorChange = (color) => {
    const newProgressBackground = {...props.metadata.options.plugins.progressBackground, backgroundColor: color}
    const newPlugins = {...props.metadata.options.plugins, progressBackground: newProgressBackground}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarDatalabelsChange = (propName, propValue) => {
    const newDatalabels = {...props.metadata.options.plugins.centerBarLabels, [propName]: propValue}
    const newPlugins = {...props.metadata.options.plugins, centerBarLabels: newDatalabels}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarPropChange = (propName, propValue) => {
    const newProgressBackground = {...props.metadata.options.plugins.progressBackground, [propName]: propValue}
    const newPlugins = {...props.metadata.options.plugins, progressBackground: newProgressBackground}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newDatasets = [...props.metadata.data.datasets]
    newDatasets[0][propName] = propValue
    const newData = {...props.metadata.data, datasets: newDatasets}
    const newMetadata = {...props.metadata, data: newData, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleScaleChange = (XY, propName, propValue) => {

    const newAxis = XY === 'x' ? {...props.metadata.options.scales.x, [propName]: propValue} : {...props.metadata.options.scales.y, [propName]: propValue}
    
    const newScales = XY === 'x' ? {...props.metadata.options.scales, x: newAxis} : {...props.metadata.options.scales, y: newAxis}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleChartIdChange = (id) => {
    setDialogData({id: id, action: 'ok', title: "Chart Change", desc: "You have chosen to change your chart type. If you proceed you will lose the current chart settings. Please confirm."})
    setOpenDialogChartChange(true)
  }
  const handleChartIdChangeDo = (id) => {
    const selectMetadata = allChartsMetadata.find(m => m.title === id)
    //console.log(selectMetadata)
    if (props.onChartIdChange) props.onChartIdChange(selectMetadata)

  }
  const hadleAnimationChange = (enable) => {
    const newMetadata = {...props.metadata, ccGenerateAnimation: {...props.metadata.ccGenerateAnimation, enabled: enable}}
    //console.log(newMetadata)
    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleMetadataChange = (metadata) => {
    if (props.onChange) props.onChange(metadata)
  }

  const getChartPreview = async (metadata, clearFilters) => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Charts/preview`;
      //attention: (for bar charts only) when we apply a gradient, the background is a function (which will be lost during serialization)
      //if this is the case then we set background = gradientColors
      if (metadata.type === 'bar') {
        for (const ds of metadata.data.datasets) {
          if (typeof ds.backgroundColor !== "string") {
            ds.backgroundColor = JSON.parse(JSON.stringify(ds.gradientColors))
          }
        }
      }

      //attention: when using url parameters, the series values might be passed as string arrays instead of int arrays
      //we need to check and correct if necessary

      //1. find series param that have string values
      const pNames = []

      for (const p of clearFilters.urlParameters) {
        //console.log(p)
        if (p.name.startsWith('s')) {
          if (typeof p.value[0] === 'string') {
            pNames.push(p.name)
            }
        }
      }
      for (const pName of pNames) {
        const match = clearFilters.urlParameters.find(p => p.name === pName)
        const newValues = match.value.map(v => parseFloat(v))
        match.value = newValues
        //console.log(match)
      }

      //if (typeof body === "string")
      //console.log(metadata)
      
      const response = await axios.post(url, {metadata: metadata, previewFilters: clearFilters, chartTitle: props.selectedChartId})


      setPreviewLoading(false);
      setPreviewImageDataUrl(response.data);

    } catch (error) {
      setPreviewLoading(false);
      console.log(error);
    }
  }
  const handleDialogClose = async(action) => {
    if (action === 'abort') {
      //do nothing
    }
    else if (action === 'ok') {
      handleChartIdChangeDo(dialogData.id)
    }

    setOpenDialogChartChange(false);
  }
  
  const handleDataConnectionChange = (dataCon) => {
    //setDataConnection(dataCon)
    if (dataCon !== undefined) getDataConnectionInfoAndSampleData(dataCon.id);
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
      handleAttachFeedInfoToMetadata(undefined)
    }
  }
    
  const updateDataConnection = async (dataConId) => {
    //setDataConnection(dataCon)
    if (dataConId !== undefined) {
      await getDataConnectionInfoAndSampleData(dataConId);
      handleAttachFeedInfoToMetadata(dataConId)
    }
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
      handleAttachFeedInfoToMetadata(undefined)
    }
  }
  const getDataConnectionInfoAndSampleData = async (dataConnectionId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
      let response = await axios.get(url);
      // let url = `api/Feeds/info/${dataConnectionId}`;
      // let response = await fetch(url, { method: "GET", });
      let data = response.data;

      //let data = await response.json();
      setDataConnectionInfo(data)
      //console.log(data)
      handleAttachFeedInfoToMetadata(data.feedId)

      // TODO ADD LOGIC TO FETCH SAMPLE DATA
      url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${dataConnectionId}`;
      response = await axios.get(url);
      // url = `api/Feeds/sample/${dataConnectionId}`;
      // response = await fetch(url, { method: "GET", });
      data = response.data;
  
      // data = await response.json();
      setSampleData(data);
      // console.log(response.data);  

    } catch (error) {
      console.log(error);
    }
  }
  const handleAttachFeedInfoToMetadata = (feedId) => {
    const newMetadata = {...props.metadata, ccFeedId: feedId}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
    
  }
  const chartUrlParamNames = (metadata) => {
    const usedParameters = []
    if (metadata.data.ccLabelsDatabindType) usedParameters.push('xLbl')
    if (metadata.options.scales.x.ccMinDatabindType) usedParameters.push('xmin')
    if (metadata.options.scales.x.ccMaxDatabindType) usedParameters.push('xmax')
    for (const ds of metadata.data.datasets) {
      if (ds.databindType && ds.databindType === 'urlChartSeries')
        usedParameters.push(ds.databindValue)
    }
    return usedParameters
  }
 const chartHasUrlParameters = (metadata) => {
  const usedParameters = chartUrlParamNames(metadata)
  return usedParameters.length > 0
  }
 const chartHasUrlParameterName = (metadata, paramName) => {
  const usedParameters = chartUrlParamNames(metadata)
  return usedParameters.indexOf(paramName) > -1
  }


  return <div>
    <div className='mb-2 flex flex-row gap-x-2 items-center'>
      <CcSecondaryActionButtonOutlined 
        onClick={handleOpenPreview}
      >Preview Chart</CcSecondaryActionButtonOutlined>

      <div className='border border-ccColorTeal rounded-lg pl-1'>
      <FormGroup>
      <FormControlLabel control={<Switch
                                  checked={props.metadata.ccGenerateAnimation.enabled}
                                  onChange={(e) => hadleAnimationChange(e.target.checked)}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                  sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                              />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'>Animated</div>}
      />
      </FormGroup>
      </div>
      <div className='border rounded border-ccColorSecondaryPurple'>
        <DatafeedPicker onDataConnectionChange={handleDataConnectionChange}
                        selectedDataconnectionId={props.metadata.ccFeedId}
        />        
      </div>

    </div>

    <div className='flex flex-row gap-x-4'>
      <div className='w-[800px] overflow-auto'><Chart metadata={props.metadata} /></div>
      <div className='h-[600px] overflow-auto'>
        <div className='border rounded p-2 flex flex-col grow'>
          <TabSelector 
            items={tabItems}
            selectedItemId={currentTab}
            onChange={setCurrentTab}
          />
          
          {currentTab === 'chart' && <div className='mt-8'>
                <LionListbox 
                  items={allChartsMetadata.filter(c => c.metadata.useSimpleEditor == undefined).map((c) => {return {id: c.title, name: c.title}})} 
                  zIndex={props.zIndex ? props.zIndex : 1000}
                  selectedItemId={props.selectedChartId} 
                  onChange={(item) => handleChartIdChange(item.id)}
                  />
                <div className='flex flex-row gap-x-4'>
                  <div className='mt-2 w-44'>
                      <InputNumber displayName="Width (px)"
                      min={50} max={1200} incr={1}
                      onChange={(val) => handleChartSizeChange(val, undefined)}
                      value={props.metadata.ccWidth}
                      />
                  </div>
                  <div className='mt-2 w-44'>
                      <InputNumber displayName="Height (px)"
                      min={50} max={1200} incr={1}
                      onChange={(val) => handleChartSizeChange(undefined, val)}
                      value={props.metadata.ccHeight}
                      />
                  </div>
                </div>
                {props.selectedChartId === 'Progress Bar' && <div className='bg-slate-100 rounded px-2 mt-2'>
                    <div className='text-ccColorDarkTeal text-lg font-semibold'>Bar properties</div>
                    <div className='flex flex-row items-start gap-x-4'>
                        <div className='mt-2 w-44'>
                            <InputNumber displayName="Thickness (px)"
                            min={4} max={300} incr={1}
                            onChange={(val) => handleProgressBarPropChange('barThickness', val)}
                            value={props.metadata.data.datasets[0].barThickness}
                            />
                        </div>
                        <div className='mt-2 mb-2'>
                          <div className='h-6 block text-sm font-medium text-gray-900'>Background color</div>
                          <LionColorPicker color={props.metadata.options.plugins.progressBackground.backgroundColor}
                          onChange={(color) => handleProgressBarBackgroudColorChange(color)}
                          />
                        </div>
                    </div>
                    <div className=''>
                      <FormGroup>
                      <FormControlLabel control={<Switch
                                                  checked={props.metadata.options.plugins.centerBarLabels.display}
                                                  onChange={(e) => handleProgressBarDatalabelsChange('display', e.target.checked)}
                                                  inputProps={{ 'aria-label': 'controlled' }}
                                                  sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                              />} label={<div className='font-semibold text-ccColorDarkTeal'>Show Progress</div>}
                      />
                      </FormGroup>
                      {props.metadata.options.plugins.centerBarLabels.display && <div>
                          <div className='flex flex-row items-start gap-x-4'>
                            <div className='mt-2 w-44'>
                                <InputNumber displayName="Font size"
                                min={4} max={300} incr={1}
                                onChange={(val) => handleProgressBarDatalabelsChange('font', {...props.metadata.options.plugins.centerBarLabels.font, size: val})}
                                value={props.metadata.options.plugins.centerBarLabels.font.size}
                                />
                            </div>
                            <div className='mt-2 mb-2'>
                              <div className='h-6 block text-sm font-medium text-gray-900'>Color</div>
                              <LionColorPicker color={props.metadata.options.plugins.centerBarLabels.color}
                              onChange={(color) => handleProgressBarDatalabelsChange('color', color)}
                              />
                            </div>
                            <div className='mt-7 flex flex-row items-center'>
                              <CcCheckbox //displayName="Show as percentage"
                                checked={props.metadata.options.plugins.centerBarLabels.ccShowProgressAsPercentage}
                                onChange={(e) => handleProgressBarDatalabelsChange('ccShowProgressAsPercentage', e.target.checked)}
                              />
                              <div className='text-sm text-ccColorDarkTeal font-poppins'>Show as percentage</div>
                            </div>

                          </div>

                        </div>}
                    </div>
                  </div>}

                <div className='mt-2 mb-2'>
                <div className='block text-sm font-medium text-gray-900'>Chart background color</div>
                <LionColorPicker color={props.metadata.options.plugins.customCanvasBackgroundColor.color}
                onChange={(color) => handleChartBackgroudColorChange(color)}
                />
                </div>

                <ChartTitleEditor metadata={props.metadata} onChange={handleChange} />
                
                <div className='mt-2 border rounded'>
                  <div className='text-sm font-medium text-gray-900'>Axis and grid</div>
                  <div className='flex flex-row items-center'>
                    <FormGroup>
                    <FormControlLabel control={<Switch
                                                checked={props.metadata.options.scales.x.display}
                                                onChange={(e) => hadleScaleChange('x', 'display', e.target.checked)}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                            />} label="X axis"
                    />
                    </FormGroup>
                    <div className='mr-12'>
                      <LionColorPicker color={props.metadata.options.scales.x.border.color}
                              onChange={(color) => hadleScaleChange('x', 'border', {...props.metadata.options.scales.x.border, color: color})}
                      />
                    </div>

                    <FormGroup>
                    <FormControlLabel control={<Switch
                                                checked={props.metadata.options.scales.x.grid.display}
                                                onChange={(e) => hadleScaleChange('x', 'grid', {...props.metadata.options.scales.x.grid, display: e.target.checked})}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                            />} label="X grid"
                    />
                    </FormGroup>
                    <div className=''>
                      <LionColorPicker color={props.metadata.options.scales.x.grid.color}
                              onChange={(color) => hadleScaleChange('x', 'grid', {...props.metadata.options.scales.x.grid, color: color})}
                      />
                    </div>

                  </div>

                  <div className='flex flex-row mt-2'>
                    <FormGroup>
                    <FormControlLabel control={<Switch
                                                checked={props.metadata.options.scales.y.display}
                                                onChange={(e) => hadleScaleChange('y', 'display', e.target.checked)}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                            />} label="Y axis"
                    />
                    </FormGroup>
                    <div className='mr-12'>
                      <LionColorPicker color={props.metadata.options.scales.y.border.color}
                              onChange={(color) => hadleScaleChange('y', 'border', {...props.metadata.options.scales.y.border, color: color})}
                      />
                    </div>

                    <FormGroup>
                    <FormControlLabel control={<Switch
                                                checked={props.metadata.options.scales.y.grid.display}
                                                onChange={(e) => hadleScaleChange('y', 'grid', {...props.metadata.options.scales.y.grid, display: e.target.checked})}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                            />} label="Y grid"
                    />
                    </FormGroup>
                    <div className=''>
                      <LionColorPicker color={props.metadata.options.scales.y.grid.color}
                              onChange={(color) => hadleScaleChange('y', 'grid', {...props.metadata.options.scales.y.grid, color: color})}
                      />
                    </div>

                  </div>

                  <div className='flex flex-row gap-x-4 mt-2'>
                    <div>
                      <div className='text-sm font-medium text-gray-900'>X Labels colour</div>
                      <LionColorPicker color={props.metadata.options.scales.x.ticks.color}
                              onChange={(color) => hadleScaleChange('x', 'ticks', {...props.metadata.options.scales.x.ticks, color: color})}
                      />
                    </div>
                    <div>
                      <div className='text-sm font-medium text-gray-900'>Y Labels colour</div>
                      <LionColorPicker color={props.metadata.options.scales.y.ticks.color}
                              onChange={(color) => hadleScaleChange('y', 'ticks', {...props.metadata.options.scales.y.ticks, color: color})}
                      />
                    </div>
                  </div>


                </div>
            </div>}

          {currentTab === 'data' && <div className='mt-8'>
          {console.log(props.selectedChartId)}
            {props.selectedChartId === 'Progress Bar (Advanced settings)' && <div className='mb-2'>
              <ProgressBarValueRangeEditor
                  metadata={props.metadata}
                  sampleData={sampleData}
                  onChange={hadleMetadataChange}
              />          
            </div>}

            <ChartSeriesEditor metadata={props.metadata}
              sampleData={sampleData}
              noAddDeleteSeries={props.selectedChartId === 'Progress Bar (Advanced settings)'}
              onChange={hadleMetadataChange} />
            </div>}
        </div>
      </div>
    </div>

      <Dialog      open={showPreview}
                    onClose={closePreview}
                    maxWidth="lg"
          >
        <DialogContent>
            <div className='w-[800px] h-[600px] flex flex-col items-center'>
               {previewLoading && <div className='mt-80 flex flex-col gap-y-1 items-center font-poppins'> 
                <CcLoader size={96} />
                <div>Loading preview</div>
                </div>}
              
              {!previewLoading && <div>
                <div className='text-ccColorDarkTeal text-xl font-semibold font-poppins text-center'>Preview</div>
                <div className='overflow-auto max-w-[800px] mt-2'>
                  <img className='max-w-none' src={previewImageDataUrl} />
                </div>
                {dataConnectionInfo && previewFilters &&
                  <div className='flex flex-col items-center mt-2 font-poppins'>
                    <div>Data row</div>
                    <div className='flex flex-row items-center gap-x-1'>
                      <div className='cursor-pointer rounded-full p-1 hover:bg-slate-200' onClick={() => handlePreviewFiltersPositionChange(-1)}><Iconify width='30' icon='material-symbols:arrow-circle-left-outline' /></div>
                      <div className='w-16 border border-slate-300 rounded text-center font-semibold text-gray-500'>
                        {previewFilters.position}
                      </div>
                      <div className='cursor-pointer rounded-full p-1 hover:bg-slate-200' onClick={() => handlePreviewFiltersPositionChange(1)}><Iconify width='30' icon='material-symbols:arrow-circle-right-outline' /></div>

                    </div>
                  </div>
                }
                {chartHasUrlParameters(props.metadata) && <div className='mt-4 text-ccColorDarkTeal font-poppins'>
                  <div className='flex flex-row items-center gap-x-2'>
                    <div className='font-semibold text-xl'>Preview URL parameters</div>
                    <CcActionButtonOutlined onClick={handleRefreshPreview}>Refresh</CcActionButtonOutlined>
                  </div>
                  {chartHasUrlParameterName(props.metadata, 'xLbl') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Axis Labels"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xLbl')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeArr('xLbl', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a comma separated list</div>
                    </div>
                  }
                  {chartHasUrlParameterName(props.metadata, 'xmin') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Min value"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xmin')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeNumber('xmin', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a number</div>
                    </div>
                  }
                  {chartHasUrlParameterName(props.metadata, 'xmax') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Max value"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xmax')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeNumber('xmax', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a number</div>
                    </div>
                  }
                  {props.metadata.data.datasets.map((ds,index) => {
                    if (chartHasUrlParameterName(props.metadata, `s${index+1}`))
                    return <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName={`s${index+1}`}
                                value={previewFilters?.urlParameters.find(p => p.name === `s${index+1}`)?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeArr(`s${index+1}`, val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a comma separated list</div>
                    </div>
                    return <></>})
                  }
                </div>
                }
                </div>}
            </div>
        </DialogContent>
      </Dialog>

      <Dialog onClose={() => handleDialogClose('abort')} open={openDialogChartChange}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">{dialogData.title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogData.desc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose(dialogData.action)} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
      </Dialog>

  </div>

}
const ChartEditorSimple = (props) => {

  const [showPreview, setShowPreview] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewImageDataUrl, setPreviewImageDataUrl] = useState('');
  const [previewFilters, setPreviewFilters] = useState(undefined);
  const [openDialogChartChange, setOpenDialogChartChange] = useState(false);
  const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});
  const tabItems = [{id: 'chart', name: 'Chart'}, {id: 'data', name: 'Data'}] 
  const [currentTab, setCurrentTab] = useState('chart')
  const [dataConnectionInfo, setDataConnectionInfo] = useState(undefined);
  const [sampleData, setSampleData] = useState({});

  useEffect(() => {
    updateDataConnection(props.dataConnectionId)
  }, [props.dataConnectionId])

  const handleChange = (metadata) => {
    if (props.onChange) props.onChange(metadata)
  }
  const closePreview = () => {
    setShowPreview(false);
    setPreviewImageDataUrl('')
  }
  const handleOpenPreview = (e, filters) => {
    const urlParameters = [{name: 'xLbl', value: props.metadata.data.labels}]
    for (const ds of props.metadata.data.datasets) {
      if (ds.databindType && ds.databindType === 'urlChartSeries') {
        urlParameters.push({name: ds.databindValue, value: ds.data})
      }
    }
    if (props.selectedChartId === 'Progress Bar') {
      urlParameters.push({name: 'xmin', value: props.metadata.options.scales.x.min})
      urlParameters.push({name: 'xmax', value: props.metadata.options.scales.x.max})
    }
    const clearFilters = {position: 1, urlParameters: urlParameters}
    //console.log(clearFilters)


    //IF filters is undefined THEN it's the first preview open -> we clear the filters
    if (filters == undefined) filters = clearFilters

    setPreviewFilters(filters)
    getChartPreview(props.metadata, filters)
    setPreviewLoading(true)
    setShowPreview(true)
  }
  const handlePreviewFiltersPositionChange = (increment) => {
    const newFilters = {...previewFilters, position: previewFilters.position + increment}
    //console.log(newFilters)
    handleOpenPreview(null, newFilters)
  }
  const handleRefreshPreview = () => {
    handleOpenPreview(null, previewFilters)
  }
  const handlePreviewParametersUrlMergeChangeArr = (paramName, paramValue) => {
    const newUrlParams = [...previewFilters.urlParameters]
    let paramValueArr = paramValue.split(',')
    newUrlParams.find(p => p.name === paramName).value = paramValueArr
    const newPreviewFilters = {...previewFilters, urlParameters: newUrlParams}

    console.log(newPreviewFilters)
    setPreviewFilters(newPreviewFilters)
    
  }
  const handlePreviewParametersUrlMergeChangeNumber = (paramName, paramValue) => {
    const newUrlParams = [...previewFilters.urlParameters]
    newUrlParams.find(p => p.name === paramName).value = parseFloat(paramValue)
    const newPreviewFilters = {...previewFilters, urlParameters: newUrlParams}

    console.log(newPreviewFilters)
    setPreviewFilters(newPreviewFilters)
    
  }

  const handleChartSizeChange = (width, height) => {
    const newMetadata = {...props.metadata, ccResize: true}
    if (width) newMetadata.ccWidth = width
    if (height) newMetadata.ccHeight = height
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleChartBackgroudColorChange = (color) => {

    const newPlugins = {...props.metadata.options.plugins, customCanvasBackgroundColor: {color: color}}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarBackgroudColorChange = (color) => {
    const newProgressBackground = {...props.metadata.options.plugins.progressBackground, backgroundColor: color}
    const newPlugins = {...props.metadata.options.plugins, progressBackground: newProgressBackground}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarDatalabelsChange = (propName, propValue) => {
    const newDatalabels = {...props.metadata.options.plugins.centerBarLabels, [propName]: propValue}
    const newPlugins = {...props.metadata.options.plugins, centerBarLabels: newDatalabels}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleProgressBarPropChange = (propName, propValue) => {
    const newProgressBackground = {...props.metadata.options.plugins.progressBackground, [propName]: propValue}
    const newPlugins = {...props.metadata.options.plugins, progressBackground: newProgressBackground}
    const newOptions = {...props.metadata.options, plugins: newPlugins}
    
    const newDatasets = [...props.metadata.data.datasets]
    newDatasets[0][propName] = propValue
    const newData = {...props.metadata.data, datasets: newDatasets}
    const newMetadata = {...props.metadata, data: newData, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleScaleChange = (XY, propName, propValue) => {

    const newAxis = XY === 'x' ? {...props.metadata.options.scales.x, [propName]: propValue} : {...props.metadata.options.scales.y, [propName]: propValue}
    
    const newScales = XY === 'x' ? {...props.metadata.options.scales, x: newAxis} : {...props.metadata.options.scales, y: newAxis}
    const newOptions = {...props.metadata.options, scales: newScales}
    
    const newMetadata = {...props.metadata, options: newOptions}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleChartIdChange = (id) => {
    setDialogData({id: id, action: 'ok', title: "Chart Change", desc: "You have chosen to change your chart type. If you proceed you will lose the current chart settings. Please confirm."})
    setOpenDialogChartChange(true)
  }
  const handleChartIdChangeDo = (id) => {
    const selectMetadata = allChartsMetadata.find(m => m.title === id)
    //console.log(selectMetadata)
    if (props.onChartIdChange) props.onChartIdChange(selectMetadata)

  }
  const hadleAnimationChange = (enable) => {
    const newMetadata = {...props.metadata, ccGenerateAnimation: {...props.metadata.ccGenerateAnimation, enabled: enable}}
    //console.log(newMetadata)
    if (props.onChange) props.onChange(newMetadata)
  }
  const hadleMetadataChange = (metadata) => {
    //console.log(metadata)
    if (props.onChange) props.onChange(metadata)
  }

  const getChartPreview = async (metadata, clearFilters) => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Charts/preview`;
      //attention: (for bar charts only) when we apply a gradient, the background is a function (which will be lost during serialization)
      //if this is the case then we set background = gradientColors
      if (metadata.type === 'bar') {
        for (const ds of metadata.data.datasets) {
          if (typeof ds.backgroundColor !== "string") {
            ds.backgroundColor = JSON.parse(JSON.stringify(ds.gradientColors))
          }
        }
      }

      //attention: when using url parameters, the series values might be passed as string arrays instead of int arrays
      //we need to check and correct if necessary

      //1. find series param that have string values
      const pNames = []

      for (const p of clearFilters.urlParameters) {
        //console.log(p)
        if (p.name.startsWith('s')) {
          if (typeof p.value[0] === 'string') {
            pNames.push(p.name)
            }
        }
      }
      for (const pName of pNames) {
        const match = clearFilters.urlParameters.find(p => p.name === pName)
        const newValues = match.value.map(v => parseFloat(v))
        match.value = newValues
        //console.log(match)
      }

      //if (typeof body === "string")
      //console.log(metadata)
      
      const response = await axios.post(url, {metadata: metadata, previewFilters: clearFilters, chartTitle: props.selectedChartId})


      setPreviewLoading(false);
      setPreviewImageDataUrl(response.data);

    } catch (error) {
      setPreviewLoading(false);
      console.log(error);
    }
  }
  const handleDialogClose = async(action) => {
    if (action === 'abort') {
      //do nothing
    }
    else if (action === 'ok') {
      handleChartIdChangeDo(dialogData.id)
    }

    setOpenDialogChartChange(false);
  }
  
  const handleDataConnectionChange = (dataCon) => {
    //setDataConnection(dataCon)
    if (dataCon !== undefined) getDataConnectionInfoAndSampleData(dataCon.id);
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
      handleAttachFeedInfoToMetadata(undefined)
    }
  }
    
  const updateDataConnection = async (dataConId) => {
    //setDataConnection(dataCon)
    if (dataConId !== undefined) {
      await getDataConnectionInfoAndSampleData(dataConId);
      handleAttachFeedInfoToMetadata(dataConId)
    }
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
      handleAttachFeedInfoToMetadata(undefined)
    }
  }
  const getDataConnectionInfoAndSampleData = async (dataConnectionId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
      let response = await axios.get(url);
      // let url = `api/Feeds/info/${dataConnectionId}`;
      // let response = await fetch(url, { method: "GET", });
      let data = response.data;

      //let data = await response.json();
      setDataConnectionInfo(data)
      //console.log(data)
      handleAttachFeedInfoToMetadata(data.feedId)

      // TODO ADD LOGIC TO FETCH SAMPLE DATA
      url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${dataConnectionId}`;
      response = await axios.get(url);
      // url = `api/Feeds/sample/${dataConnectionId}`;
      // response = await fetch(url, { method: "GET", });
      data = response.data;
  
      // data = await response.json();
      setSampleData(data);
      // console.log(response.data);  

    } catch (error) {
      console.log(error);
    }
  }
  const handleAttachFeedInfoToMetadata = (feedId) => {
    const newMetadata = {...props.metadata, ccFeedId: feedId}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
    
  }
  const chartUrlParamNames = (metadata) => {
    const usedParameters = []
    if (metadata.data.ccLabelsDatabindType) usedParameters.push('xLbl')
    if (metadata.options.scales.x.ccMinDatabindType) usedParameters.push('xmin')
    if (metadata.options.scales.x.ccMaxDatabindType) usedParameters.push('xmax')
    for (const ds of metadata.data.datasets) {
      if (ds.databindType && ds.databindType === 'urlChartSeries')
        usedParameters.push(ds.databindValue)
    }
    return usedParameters
  }
 const chartHasUrlParameters = (metadata) => {
  const usedParameters = chartUrlParamNames(metadata)
  return usedParameters.length > 0
  }
 const chartHasUrlParameterName = (metadata, paramName) => {
  const usedParameters = chartUrlParamNames(metadata)
  return usedParameters.indexOf(paramName) > -1
  }
const handleProgressBarValueChange = (val) => {
  const newMetadata = {...props.metadata}
  newMetadata.data.datasets[0].data[0] = val
  //console.log(newMetadata)
  hadleMetadataChange(newMetadata)

}
  const getSeriesColor = (ds, index) => {
    // we need to read the backgroundColor prop which can be a string or an array of strings or a function
    if (typeof ds.backgroundColor !== 'string' && !Array.isArray(ds.backgroundColor)) {
      //if we are here it's a function
      //it means there is a gradient applied and the colors are in the gradientColors prop
      return ds.gradientColors[index]
    }

    if (typeof ds.backgroundColor === 'string') {
      if (index > 0) return '#000000'
      else return ds.backgroundColor
    }
    else {
      //if we are here it's an array
      return ds.backgroundColor[index]
    }
  }
  const isSeriesColorGradient = (ds) => {
    if (typeof ds.backgroundColor !== 'string' && !Array.isArray(ds.backgroundColor)) {
      //if we are here the backgroundColor is a function
      //it means there is a gradient
      return true
    }

    if (typeof ds.backgroundColor === 'string') {
      return false
    }
    else {
      //if we are here it's an array
      return true
    }
  }
  const setSeriesColorAsGradient = (dsIndex, isGradient) => {
    const newDatasets = [...props.metadata.data.datasets]

    if (isGradient) {
      const color1 = newDatasets[dsIndex].backgroundColor
      const color2 = '#000000'
      const newGradientColors = [color1, color2]
      newDatasets[dsIndex].backgroundColor = newGradientColors
    }
    else {
      newDatasets[dsIndex].backgroundColor = newDatasets[dsIndex].gradientColors[0]
      newDatasets[dsIndex].gradientColors = undefined
    }
    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }
  const handleSeriesColorChange = (dsIndex, colorIndex, color) => {
    const newDatasets = [...props.metadata.data.datasets]

    if (isSeriesColorGradient(newDatasets[dsIndex])) {
      const newGradientColors = [...newDatasets[dsIndex].gradientColors]
      newGradientColors.splice(colorIndex,1,color)
      newDatasets[dsIndex].gradientColors = newGradientColors
    }
    else {
      newDatasets[dsIndex].backgroundColor = color
    }
    const newData = {...props.metadata.data, datasets: newDatasets}
    
    const newMetadata = {...props.metadata, data: newData}
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }

  return <div>
    <div className='mb-2 flex flex-row gap-x-2 items-center'>
      <CcSecondaryActionButtonOutlined 
        onClick={handleOpenPreview}
      >Preview Chart</CcSecondaryActionButtonOutlined>

      <div className='border border-ccColorTeal rounded-lg pl-1'>
      <FormGroup>
      <FormControlLabel control={<Switch
                                  checked={props.metadata.ccGenerateAnimation.enabled}
                                  onChange={(e) => hadleAnimationChange(e.target.checked)}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                  sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                              />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'>Animated</div>}
      />
      </FormGroup>
      </div>
    </div>

    <div className='flex flex-col gap-x-4'>
      <div className='w-[800px] overflow-auto'><Chart metadata={props.metadata} /></div>


    {props.selectedChartId === 'Progress Bar' && <div className='w-[576px]'>
      <div className='bg-slate-100 rounded p-2'>
        <div className='text-ccColorDarkTeal text-lg font-semibold'>Data</div>
        <div className='flex flex-row gap-x-4 items-center'>
          <ProgressBarValueRangeEditorSimple
              metadata={props.metadata}
              sampleData={sampleData}
              onChange={hadleMetadataChange}
          />
          <div className='mt-2 w-44'>
          <InputNumber
              displayName="Value"
              value={props.metadata.data.datasets[0].data[0]}
              onChange={handleProgressBarValueChange}
          />
          </div>
        </div>
      </div>

    </div>}


    <div className='bg-slate-100 w-fit rounded px-2 mt-4 w-[576px]'>
        <div className='text-ccColorDarkTeal text-lg font-semibold'>Chart properties</div>
        <div className='flex flex-row gap-x-4'>
          <div className='mt-2 w-44'>
              <InputNumber displayName="Width (px)"
              min={50} max={1200} incr={1}
              onChange={(val) => handleChartSizeChange(val, undefined)}
              value={props.metadata.ccWidth}
              />
          </div>
          <div className='mt-2 w-44'>
              <InputNumber displayName="Height (px)"
              min={50} max={1200} incr={1}
              onChange={(val) => handleChartSizeChange(undefined, val)}
              value={props.metadata.ccHeight}
              />
          </div>
        </div>
      
        <div className='mt-2 mb-2'>
          <div className='block text-sm font-medium text-gray-900'>Chart background color</div>
            <LionColorPicker color={props.metadata.options.plugins.customCanvasBackgroundColor.color}
            onChange={(color) => handleChartBackgroudColorChange(color)}
            />
        </div>
    </div>

    {props.selectedChartId === 'Progress Bar' && <div className='bg-slate-100 w-[576px] rounded px-2 mt-4'>
        <div className='text-ccColorDarkTeal text-lg font-semibold'>Bar properties</div>
        <div className='flex flex-row items-start gap-x-4'>
            <div className='mt-2 w-44'>
                <InputNumber displayName="Thickness (px)"
                min={4} max={300} incr={1}
                onChange={(val) => handleProgressBarPropChange('barThickness', val)}
                value={props.metadata.data.datasets[0].barThickness}
                />
            </div>
            <div className='mt-2 mb-2'>
              <div className='h-6 block text-sm font-medium text-gray-900'>Background color</div>
              <LionColorPicker color={props.metadata.options.plugins.progressBackground.backgroundColor}
              onChange={(color) => handleProgressBarBackgroudColorChange(color)}
              />
            </div>
        </div>

      <div className='flex flex-row gap-x-8 items-end'>
        <div className='mt-2 mb-2'>
          <div className='block text-sm font-medium text-gray-900'>Color 1</div>
          <LionColorPicker color={getSeriesColor(props.metadata.data.datasets[0], 0)}
              onChange={(color) => handleSeriesColorChange(0, 0, color)}
          />
        </div>
        <div className='mt-2 mb-2'>
          <div className='flex flex-row items-center gap-x-2 -mb-1'>
            <div className='block text-sm font-medium text-gray-900'>Color 2</div>
            <FormGroup>
            <FormControlLabel control={<Switch
                                        checked={isSeriesColorGradient(props.metadata.data.datasets[0])}
                                        onChange={(e) => setSeriesColorAsGradient(0, e.target.checked)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                    />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'></div>}
            />
            </FormGroup>
            <div className='-ml-6'>
              <InfoToolTip 
                placement='right'
                headLine='Color gradient'
                message={<div>Enable <span className='font-bold'>Color 2</span> to apply a gradient to this series</div>}
              />
            </div>
          </div>
          {isSeriesColorGradient(props.metadata.data.datasets[0]) &&  <LionColorPicker color={getSeriesColor(props.metadata.data.datasets[0], 1)}
              onChange={(color) => handleSeriesColorChange(0, 1, color)}
          />
          }
          {!isSeriesColorGradient(props.metadata.data.datasets[0]) &&  <div className='h-10 flex items-center'>
            <div className='font-poppins text-gray-500'>Not used</div>
          </div>
          }
        </div>

      </div>


        <div className=''>
          <FormGroup>
          <FormControlLabel control={<Switch
                                      checked={props.metadata.options.plugins.centerBarLabels.display}
                                      onChange={(e) => handleProgressBarDatalabelsChange('display', e.target.checked)}
                                      inputProps={{ 'aria-label': 'controlled' }}
                                      sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                  />} label={<div className='font-semibold text-ccColorDarkTeal'>Show Progress</div>}
          />
          </FormGroup>
          {props.metadata.options.plugins.centerBarLabels.display && <div>
              <div className='flex flex-row items-start gap-x-4'>
                <div className='mt-2 w-44'>
                    <InputNumber displayName="Font size"
                    min={4} max={300} incr={1}
                    onChange={(val) => handleProgressBarDatalabelsChange('font', {...props.metadata.options.plugins.centerBarLabels.font, size: val})}
                    value={props.metadata.options.plugins.centerBarLabels.font.size}
                    />
                </div>
                <div className='mt-2 mb-2'>
                  <div className='h-6 block text-sm font-medium text-gray-900'>Color</div>
                  <LionColorPicker color={props.metadata.options.plugins.centerBarLabels.color}
                  onChange={(color) => handleProgressBarDatalabelsChange('color', color)}
                  />
                </div>
                <div className='mt-7 flex flex-row items-center'>
                  <CcCheckbox //displayName="Show as percentage"
                    checked={props.metadata.options.plugins.centerBarLabels.ccShowProgressAsPercentage}
                    onChange={(e) => handleProgressBarDatalabelsChange('ccShowProgressAsPercentage', e.target.checked)}
                  />
                  <div className='text-sm text-ccColorDarkTeal font-poppins'>Show as percentage</div>
                </div>

              </div>

            </div>}
        </div>
      </div>}



    </div>

      <Dialog      open={showPreview}
                    onClose={closePreview}
                    maxWidth="lg"
          >
        <DialogContent>
            <div className='w-[800px] h-[600px] flex flex-col items-center'>
               {previewLoading && <div className='mt-80 flex flex-col gap-y-1 items-center font-poppins'> 
                <CcLoader size={96} />
                <div>Loading preview</div>
                </div>}
              
              {!previewLoading && <div>
                <div className='text-ccColorDarkTeal text-xl font-semibold font-poppins text-center'>Preview</div>
                <div className='overflow-auto max-w-[800px] mt-2'>
                  <img className='max-w-none' src={previewImageDataUrl} />
                </div>
                {dataConnectionInfo && previewFilters &&
                  <div className='flex flex-col items-center mt-2 font-poppins'>
                    <div>Data row</div>
                    <div className='flex flex-row items-center gap-x-1'>
                      <div className='cursor-pointer rounded-full p-1 hover:bg-slate-200' onClick={() => handlePreviewFiltersPositionChange(-1)}><Iconify width='30' icon='material-symbols:arrow-circle-left-outline' /></div>
                      <div className='w-16 border border-slate-300 rounded text-center font-semibold text-gray-500'>
                        {previewFilters.position}
                      </div>
                      <div className='cursor-pointer rounded-full p-1 hover:bg-slate-200' onClick={() => handlePreviewFiltersPositionChange(1)}><Iconify width='30' icon='material-symbols:arrow-circle-right-outline' /></div>

                    </div>
                  </div>
                }
                {chartHasUrlParameters(props.metadata) && <div className='mt-4 text-ccColorDarkTeal font-poppins'>
                  <div className='flex flex-row items-center gap-x-2'>
                    <div className='font-semibold text-xl'>Preview URL parameters</div>
                    <CcActionButtonOutlined onClick={handleRefreshPreview}>Refresh</CcActionButtonOutlined>
                  </div>
                  {chartHasUrlParameterName(props.metadata, 'xLbl') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Axis Labels"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xLbl')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeArr('xLbl', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a comma separated list</div>
                    </div>
                  }
                  {chartHasUrlParameterName(props.metadata, 'xmin') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Min value"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xmin')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeNumber('xmin', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a number</div>
                    </div>
                  }
                  {chartHasUrlParameterName(props.metadata, 'xmax') &&
                    <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName="Max value"
                                value={previewFilters?.urlParameters.find(p => p.name === 'xmax')?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeNumber('xmax', val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a number</div>
                    </div>
                  }
                  {props.metadata.data.datasets.map((ds,index) => {
                    if (chartHasUrlParameterName(props.metadata, `s${index+1}`))
                    return <div className='mt-2 flex flex-row items-end gap-x-4'>
                      <div className="w-64">
                        <InputText
                                displayName={`s${index+1}`}
                                value={previewFilters?.urlParameters.find(p => p.name === `s${index+1}`)?.value}
                                onChange={(val) => {handlePreviewParametersUrlMergeChangeArr(`s${index+1}`, val);}}
                                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                        />
                      </div>
                      <div className='text-sm'>Provide a comma separated list</div>
                    </div>
                    return <></>})
                  }
                </div>
                }
                </div>}
            </div>
        </DialogContent>
      </Dialog>

      <Dialog onClose={() => handleDialogClose('abort')} open={openDialogChartChange}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">{dialogData.title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogData.desc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose(dialogData.action)} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
      </Dialog>

  </div>

}

export default function ChartWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [snippetData, setSnippetData] = useState({});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
        
    const [selectedChartMetadata, setSelectedChartMetadata] = useState(undefined);
    const [selectedChartId, setSelectedChartId] = useState(undefined); //we use the title as the id
    const [isEdit, setIsEdit] = useState(false)
    const [showFallbackImageError, setShowFallbackImageError] = useState(false)
    const [openDialogWarning, setOpenDialogWarning] = useState(false)
    const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});

    const stepsForEdit = [{ name: 'Customize chart', href: '#' },
                    { name: 'Configure Element', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]
    const stepsForNew = [{ name: 'Select chart type', href: '#' },
                    { name: 'Customize chart', href: '#' },
                    { name: 'Configure Element', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
        setIsEdit(true)
      }
      else setIsEdit(false)
    }, [props.snippetId])


    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        const chartMetadata = JSON.parse(response.data.snippetSettings)
        setSelectedChartId(chartMetadata.selectedChartId)
        //if the series had gradients applied then backgroundColor will be undefined
        //since it was a gradient function that gets lost during serialization
        //in this case we'll set it with the gradient colors again
        for (const ds of chartMetadata.data.datasets) {
          if (ds.backgroundColor == undefined) ds.backgroundColor = ds.gradientColors
        }
        //similarly we need to re-attach the plugins
        ApplyFormatterFunction(chartMetadata)
        //console.log(chartMetadata)
        chartMetadata.plugins = [progressBackgroundPlugin, backgroundPlugin, CenterBarLabelsPlugin]
        

        setSelectedChartMetadata(chartMetadata);
        //adding new metadata for compatibility with old tags that don't have it
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

    const submitDataSnippet = async () => {
      try {
        //console.log(snippetData)
        snippetDataChartsValidationSchema.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return false;
      }
      //we also need a manual validation of the fallback image if used
      if (selectedChartMetadata.ccFallback.fallbackType === "showImage" && selectedChartMetadata.ccFallback.fallbackImage.length === 0) {
        setShowFallbackImageError(true)
        return false
      }

      setShowLoader(true);
      setSuccessHtmlMsg('');
      setCurrentStep(currentStep+1)
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/23`;
          if (isEdit) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/23/${params.snippetId}`;
          
          const response = await axios.post(url, {...snippetData, snippetSettings: JSON.stringify({...selectedChartMetadata, selectedChartId: selectedChartId})});
    
          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleChartElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataChartsValidationSchema.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleChartElementFallbackChange = (fallbackInfo) => {
    const newChartMetadata = {...selectedChartMetadata, ccFallback: fallbackInfo}
    setSelectedChartMetadata(newChartMetadata)
    if (fallbackInfo.fallbackType === 'hide' || fallbackInfo.fallbackImage.length > 0) setShowFallbackImageError(false)
  }
      
  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Submit') {
          const valid = await submitDataSnippet()
          if (valid) setCurrentStep(navInfo.nextIndex);
      }
    else {
      if (currentStep === 1 && navInfo.nextIndex === 2) {
        if (!chartContainsDataBindings(selectedChartMetadata)) {
          setDialogData({action: 'proceed', title: 'Connect to data', desc: 'Your series are not connected to any data. If you proceed, your tag will always display the same data chart. Would you like to proceed anyway?', nextStep: navInfo.nextIndex})
          setOpenDialogWarning(true)
        }
        else
          setCurrentStep(navInfo.nextIndex);
      }
      else
        setCurrentStep(navInfo.nextIndex);
    }
  }
    
  const handleClose = () => {
      navigate("/ph/charts")
  }
  const chartContainsDataBindings = (metadata) => {
    //check if users has connected at least 1 series to some data
    //(either to a data connection or to a url-parameter)
    let result = false
    for (const ds of metadata.data.datasets) {
        if (ds.databindType && (ds.databindType === 'urlChartSeries' || ds.databindType === 'databind')) {
          result = true
          break
        }
    }
    return result
  }

  const handleSelectedChartChange = (metadata, id) => {
    //this is only used when a chart is selected from the gallery
    //we want to make the chart a bit larger before going to the editor
    //we also remove the animation
    //we also set default fallback settings
    let newWidth = 600
    let newHeight = 300
    switch (id) {
      case "Progress Bar":
        newWidth = 360
        newHeight = 80
        break
      default:
        break
    }
    const newOptions = {...metadata.options, animation: false}
    const metadataNewSize = {...metadata, ccWidth: newWidth, ccHeight: newHeight, options: newOptions,
                              ccFallback: {fallbackType: 'hide', fallbackImage: ''}
    }
    
    setSelectedChartMetadata(metadataNewSize)
    setSelectedChartId(id)
  }
  const handleChartMetadataChange = (metadata) => {
    //this is used when the chart metadata has been changed by the ChartEditor
    //console.log(metadata)
    
    setSelectedChartMetadata(metadata)
  }
  const handleChartIdChange = (chartInfo) => {
    const newOptions = {...chartInfo.metadata.options, animation: false}
    const metadataNewSize = {...chartInfo.metadata, ccWidth: 600, ccHeight: 300, options: newOptions}
    
    setSelectedChartMetadata(metadataNewSize)
    setSelectedChartId(chartInfo.title)
  }
  const handleDialogClose = async(action) => {
    if (action === 'abort') {
      //do nothing
    }
    else if (action === 'ok') {
      //handleChartIdChangeDo(dialogData.id)
    }
    else if (action === 'proceed') {
      setCurrentStep(dialogData.nextStep)
    }

    setOpenDialogWarning(false);
  }

    return <div>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

        <CcStepper2
            steps={isEdit ? stepsForEdit : stepsForNew}
            currentStepIndex={currentStep}
        />
        {!isEdit &&
            <div className="border border-2 border-gray-200 rounded-md p-2">
                {currentStep === 0 && <div>
                    <ChartGallery onChange={handleSelectedChartChange} />
                </div>}

                {currentStep === 1 && <>
                  {selectedChartMetadata.useSimpleEditor ?
                    <ChartEditorSimple metadata={selectedChartMetadata} selectedChartId={selectedChartId} dataConnectionId={selectedChartMetadata.ccFeedId} onChange={handleChartMetadataChange} onChartIdChange={handleChartIdChange} />
                    :
                    <ChartEditor metadata={selectedChartMetadata} selectedChartId={selectedChartId} dataConnectionId={selectedChartMetadata.ccFeedId} onChange={handleChartMetadataChange} onChartIdChange={handleChartIdChange} />
                  }
                </>
                        
                }
                {currentStep === 2 && <ChartElementManager
                                        snippetInfo={snippetData}
                                        onChange={handleChartElementChange}
                                        onFallbackChange={handleChartElementFallbackChange}
                                        fallback={selectedChartMetadata.ccFallback}
                                        fallbackImageError={showFallbackImageError}
                                        validationErrorsList={activeErrorList}
                  />}

                {currentStep === 3 && <div className='flex justify-center'>
                    {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                    {showLoader && <div className='mt-8'><CcLoader size={96} /></div> }
                    {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                </div>}
                <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />

            </div>
        }
        {isEdit &&
            <div className="border border-2 border-gray-200 rounded-md p-2">
                {currentStep === 0 && <>
                  {selectedChartMetadata.useSimpleEditor ?
                    <ChartEditorSimple metadata={selectedChartMetadata} selectedChartId={selectedChartId} dataConnectionId={selectedChartMetadata.ccFeedId} onChange={handleChartMetadataChange} onChartIdChange={handleChartIdChange} />
                    :
                    <ChartEditor metadata={selectedChartMetadata} selectedChartId={selectedChartId} dataConnectionId={selectedChartMetadata.ccFeedId} onChange={handleChartMetadataChange} onChartIdChange={handleChartIdChange} />
                  }
                </>                        
                }
                {currentStep === 1 && <ChartElementManager
                                        snippetInfo={snippetData}
                                        onChange={handleChartElementChange}
                                        onFallbackChange={handleChartElementFallbackChange}
                                        fallback={selectedChartMetadata.ccFallback}
                                        fallbackImageError={showFallbackImageError}
                                        validationErrorsList={activeErrorList}
                  />}

                {currentStep === 2 && <div className='flex justify-center'>
                    {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                    {showLoader && <div className='mt-8'><CcLoader size={96} /></div> }
                    {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                </div>}
                <StepperNavButtons totalSteps={3}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />

            </div>
        }
      <Dialog onClose={() => handleDialogClose('abort')} open={openDialogWarning}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">{dialogData.title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogData.desc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose(dialogData.action)} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
      </Dialog>

    </div>
}